import React from 'react';

const variants = {
  blue: 'ui-badge-blue',
  green: 'ui-badge-green',
  amber: 'ui-badge-amber',
  red: 'ui-badge-red',
  slate: 'ui-badge-slate',
  purple: 'ui-badge-purple',
};

export default function Badge({ children, variant = 'slate', className = '' }) {
  return (
    <span className={`ui-badge ${variants[variant] || variants.slate} ${className}`}>
      {children}
    </span>
  );
}

export function statusVariant(status = '') {
  const normalized = String(status).toLowerCase();
  if (['active', 'available', 'scheduled', 'success', 'completed', 'open'].includes(normalized)) return 'green';
  if (['pending', 'partial', 'on leave', 'waiting'].includes(normalized)) return 'amber';
  if (['inactive', 'deleted', 'cancelled', 'not available', 'offline', 'closed', 'discharged'].includes(normalized)) return 'red';
  if (['general', 'info'].includes(normalized)) return 'blue';
  return 'slate';
}
